





























import _ from 'lodash'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { ISchedule } from '@/store/modules/views/schedule/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import ScheduleDetail from '@/components/today/ScheduleDetail.vue'
import PatientDetail from '@/components/today/PatientDetail.vue'
import { IJob } from '@/store/modules/views/job/states'

@Component({
  components: {
    ScheduleDetail,
    PatientDetail,
  },
})
export default class EventDialog extends VueExtendedBaseComponent {
  @Prop() public eventData!: ISchedule
  @Prop() private open!: boolean

  @Getter('job/jobById')
  private jobById!: IJob

  get openDialog() {
    return this.open
  }

  get createJobDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
      },
    }
  }

  @Action('job/getJobById')
  private getJobById!: (options: {}) => void

  private closeDialog() {
    this.$emit('update:open', false)
  }

  private async created() {
    if (this.eventData && this.eventData.jobId) {
      await this.getJobById({ _id: this.eventData.jobId })
    }
  }
}
